export default __webpack_public_path__ + "static/media/ic-chat-active.3a8859c4.svg";